import React from "react";
import UserHeader from "./UserComponents/UserHeader";

const Punchpass = () => {
  return (
    <div>
      <UserHeader />
      <p>map of instructor created punch passes to buy</p>
    </div>
  );
};

export default Punchpass;
